import { Typography, Space, Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
// import styled from "styled-components";
// const StyledCard = styled<any>(Card)`
//   border-radius: 8px;
//   .ant-card-bordered {
//     border: 0px !important;
//   }
//   .ant-card-body {
//     padding: 12px !important;
//   }
// `;
const QuizCard = ({ quiz }: any) => {
  const { quizTitle, id } = quiz;
  const { setEditableQuiz, setIsCreateMode, isQuizEditable } = useQuizContext();
  return (
    <>
      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "space-between" }}
      >
        <Space direction="horizontal" size={4}>
          <Typography.Text strong>{quizTitle}</Typography.Text>

          <Space size={8}>
            <Tag color="blue">ID: {id}</Tag>
          </Space>
        </Space>
        <Typography.Text type="secondary">
          {quiz?.date} · {quiz?.responses}
        </Typography.Text>
        {isQuizEditable && (
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => {
              setEditableQuiz(quiz);
              setIsCreateMode(true);
            }}
          />
        )}
      </Space>
    </>
  );
};

export default QuizCard;
